import { useTranslation } from 'react-i18next';
import Tabs from '../components/UI/Tabs';
import { PotentialsType } from '../enums/PotentialsType';
import Auswertung from '../components/Potentials/Auswertung';
import { LocationPriority } from '../enums/LocationPriority';
import Potentials from './Potentials';

export default function PotentialsTabs() {
    const { t } = useTranslation();
    const tabs = [
        {
            label: t('potentials.tabOffered'),
            tabPanel: <Potentials type={PotentialsType.TEF_OFFERED} />,
        },
        {
            label: t('potentials.tabHandled'),
            tabPanel: <Potentials type={PotentialsType.CALL_CENTER} />,
        },
        {
            label: t('potentials.tabEvalPrio1'),
            tabPanel: <Auswertung locationPriority={LocationPriority.ONE}></Auswertung>,
        },
        {
            label: t('potentials.tabEvalPrioAll'),
            tabPanel: <Auswertung locationPriority={LocationPriority.ALL}></Auswertung>,
        },
    ];

    return <Tabs tabs={tabs}></Tabs>;
}
